export const SUBMIT_BUG_REPORT = '/api/ticketing/SubmitBugTicket';
// ********************* auth panel rest commands *************************
export const GET_COUNTRIES = '/api/usermanagement/GetCountries';
export const GET_CURRENCIES = '/api/usermanagement/GetCurrencies';
export const CHANGE_PASSWORD = '/api/usermanagement/ChangePassword';
export const REGISTER_EMPLOYEE = '/api/usermanagement/RegisterEmployee';
export const UPDATE_PERMISSIONS = '/api/usermanagement/UpdatePermissions';
export const GET_USER_PROFILE = '/api/usermanagement/GetUserProfile';
export const CHANGE_PASSWORD_WITH_ID =
  '/api/usermanagement/ChangePasswordWithId';
export const UPDATE_OWN_ADDRESS = '/api/usermanagement/UpdateOwnAddress';
export const UPDATE_OWN_PROFILE = '/api/usermanagement/UpdateOwnProfile';
export const UPDATE_EMPLOYEE_ADDRESS =
  '/api/usermanagement/UpdateEmployeeAddress';
export const UPDATE_EMPLOYEE = '/api/usermanagement/UpdateEmployee';
export const GET_CITIES = '/api/usermanagement/GetCities';
export const GET_STATES = '/api/usermanagement/GetStates';
export const GET_EMPLOYEE = '/api/usermanagement/GetEmployee';
export const GET_EMPLOYEE_LIST = '/api/usermanagement/GetEmployeeList';
export const CHECK_USER_NAME = '/api/usermanagement/IsUserNameExist';
export const LOCKOUT_EMPLOYEE = '/api/usermanagement/LockoutEmployee';
export const GET_EMPLOYEE_PERMISSION_LIST =
  '/api/usermanagement/GetEmployeePermissionList';
export const DELETE_EMPLOYEE = '/api/usermanagement/DeleteEmployee';
export const BUY_TRIAL_VERSION = '/api/BuyVersion/BuyTrialVersion';
export const GET_PRICING_LIST = '/api/BuyVersion/GetPricingList';
export const NEW_INVOICE_NUMBER = '/api/BuyVersion/NewInvoinceNumber';
export const BUY_VERSION = '/api/BuyVersion/buy';
export const ACTIVE_BUY_VERSION = '/api/BuyVersion/ActiveBuyVersion';
export const GET_BOUGHT_LIST = '/api/BuyVersion/GetBoughtList';
export const GET_EMPLOYEES = '/api/UserManagement/GetEmployees';
export const GET_EMPLOYEES_PROFILE = '/api/UserManagement/GetEmployeesProfile';
export const EXECUTE_PAYMENT_RECEIPT = '/api/Accounting/ExecutePaymentReceipt';
export const INCREASE_SERVICE_PROVIDER_CREDIT =
  '/api/tpm/IncreaseServiceProviderCredit ';
export const GET_ORGANIZATION_CHART =
  '/api/usermanagement/GetOrganizationChart';
export const GET_VALID_SHARE_PERCENT =
  '/api/usermanagement/GetValidSharePercent';
export const ADD_BRANCH = '/api/usermanagement/AddBranch';
export const EDIT_BRANCH = '/api/usermanagement/EditBranch';
export const GET_BRANCH = '/api/usermanagement/GetBranch';
export const BLOCK_BRANCH = '/api/usermanagement/BlockBranch';
export const GET_ALL_BRANCHES = '/api/usermanagement/GetAllBranches';
export const CREATE_ORGANIZATION_GROUP =
  '/api/UserManagement/CreateOrganizationGroup';
export const UPDATE_ORGANIZATION_GROUP =
  '/api/UserManagement/UpdateOrganizationGroup';
export const DELETE_ORGANIZATION_GROUP =
  '/api/UserManagement/DeleteOrganizationGroup';
export const GET_ORGANIZATION_TITLES =
  '/api/UserManagement/GetOrganizationTitles';
export const GET_ORGANIZATION_GROUPS =
  '/api/UserManagement/GetOrganizationGroups';
export const GET_ORGANIZATION_TREE = '/api/UserManagement/GetOrganizationTree';
// ********************* accounting panel rest commands *************************
export const SUBMIT_CASH_TRANSACTION = '/api/Accounting/SubmitCashTransaction';
export const UPDATE_CASH_TRANSACTION = '/api/Accounting/UpdateCashTransaction';
export const SUBMIT_BANK_TRANSACTION = '/api/Banking/SubmitBankTransaction';
export const UPDATE_BANK_TRANSACTION = '/api/Banking/UpdateBankTransaction';
export const SUBMIT_TRANSFER_BETWEEN_ACCOUNTS_TRANSACTION =
  '/api/Accounting/SubmitTransferBetweenAccountsTransaction';
export const UPDATE_TRANSFER_BETWEEN_ACCOUNTS_TRANSACTION =
  '/api/Accounting/UpdateTransferBetweenAccountsTransaction';
export const SUBMIT_OR_UPDATE_INCOMING_DRAFT =
  '/api/BranchManagement/SubmitOrUpdateIncomingDraft';
export const SUBMIT_OR_UPDATE_OUTGOING_DRAFT =
  '/api/BranchManagement/SubmitOrUpdateOutgoingDraft';
export const EDIT_PEND_DRAFT = '/api/BranchManagement/editPendDraft';
export const SUBMIT_MISCELLANEOUS_DRAFT =
  '/api/Accounting/SubmitorUpdateMiscellaneous';
export const UPDATE_MISCELLANEOUS_DRAFT =
  '/api/Accounting/UpdateMiscellaneouse';
export const REGISTER_OR_UPDATE_PERSON = '/api/Identity/RegisterOrUpdatePerson';
export const FAST_REGISTER_OR_UPDATE_PERSON =
  '/api/identity/FastRegisterPerson';
export const REGISTER_OR_UPDATE_COMPANY =
  '/api/Identity/RegisterOrUpdateCompany';
export const SUBMIT_ATTACHMENT = '/api/Identity/AddAttachmentToPerson';
export const ADD_OR_EDIT_PERSON_DOCUMENT =
  '/api/Identity/AddOrEditPersonDocument';
export const EXECUTE_DRAFT = '/api/BranchManagement/ExecuteDraft';
export const SUBMIT_TRADE_CURRENCY = '/api/TradeCurrency/SubmitTradeCurrency';
export const UPDATE_TRADE_CURRENCY = '/api/TradeCurrency/UpdateTradeCurrency';
export const SUBMIT_INTERBANK_TRANSACTION =
  '/api/Banking/SubmitInterbankTransaction';
export const UPDATE_INTERBANK_TRANSACTION =
  '/api/Banking/UpdateInterbankTransaction';
export const SUBMIT_CHEQUE = '/api/Accounting/SubmitCheque';
export const UPDATE_CHEQUE = '/api/Accounting/UpdateCheque';
export const DOWNLOAD_FILE = '/api/Download/DownloadFile';
export const SUBMIT_OR_UPDATE_SETTLEMEN_DRAFT =
  '/api/creditManagement/determineDocumentWithDraftOrder';
export const DOWNLOAD_BALANCE_EXCEL_FILE =
  '/api/Download/downloadBalanceSheetExcel';
export const DOWNLOAD_PROFIT_AND_LOSS_EXCEL_FILE =
  '/api/Download/downloadProfitAndLossExcel';
export const DOWNLOAD_ITEMS_AND_LOSS_EXCEL_FILE =
  '/api/Download/downloadItemsAndLossExcel';
export const SUBMIT_OR_UPDATE_SYSTEM_SETTINGS =
  '/api/Settings/SubmitOrEditSystemSettings';
export const UPDATE_SYSTEM_SETTINGS = '/api/Settings/UpdateSystemSettings';
export const INCREASE_CREDIT = '/api/creditManagement/IncreaseCredit';
export const DECREASE_CREDIT = '/api/creditManagement/DecreaseCredit';
export const SETTLE_TRANSFER_BETWEEN_ACCOUNTS =
  '/api/Accounting/determineDocumentWithAccountingTransaction';
export const SETTLE_CREDIT_TRANSFER_BETWEEN_ACCOUNTS =
  '/api/creditManagement/determineDocumentWithAccountingTransaction';
export const SETTLE_BANK_TRANSACTION =
  '/api/Accounting/determineDocumentWithBankTransaction';
export const SETTLE_CREDIT_BANK_TRANSACTION =
  '/api/creditManagement/determineDocumentWithBankTransaction';
export const CANCEL_DRAFT = '/api/BranchManagement/cancelDraft';
export const CONFIRM_PAYMRNT_RECEIPT =
  '/api/creditManagement/confirmPaymentReceipt';

// ********************* support rest commands *************************
export const GET_MANAGERS = '/api/UserManagement/GetManagers';
export const GET_MANAGER_LIST = '/api/UserManagement/GetManagerList';
export const GET_DEVELOPERS = '/api/UserManagement/GetDevelopers';
export const GET_CURRENT_ACTIVE_VERSION =
  '/api/BuyVersion/GetCurrentActiveVersion';
export const BUY_VERSION_BY_OPERATOR = '/api/BuyVersion/BuyVersionByOperator';
export const ACCESS_TO_WHATSAPP = '/api/UserManagement/AccessToWhatsApp';
export const CREATE_USER = '/api/usermanagement/CreateUser';
export const GET_PROFILE = '/api/UserManagement/GetProfile';
export const CONTINUE_CONVERSATION_FOR_SUPPORT_TEAM =
  '/api/ticketing/ContinueConversationForSupportTeam';
export const CONTINUE_CONVERSATION_FOR_EXCHANGER =
  '/api/ticketing/ContinueConversationForExchanger';
export const CHANGE_TO_SIMULATE_USER =
  '/api/UserManagement/ChangeUserToSimulateUser';
export const CHANGE_USER_PASSWORD = '/api/usermanagement/ChangePasswordByAdmin';
export const GET_WHATSAPP_SESSION = '/api/usermanagement/GetWhatsAppSession';
export const GET_MANAGER_DETAILS = '/api/UserManagement/GetManagerDetails';
// ********************* Export Excel rest commands *************************
export const EXPORT_EXCEL = '/api/export/exportExcel';
export const CHECK_EXPORT_EXCEL = '/api/export/checkExportState';
export const REPORT_EXCEL_ITEM_AND_LOSS = '/api/Download/itemsAndLoss';
export const REPORT_EXCEL_PROFIT_AND_LOSS = '/api/Download/profitAndLossData';
export const REPORT_EXCEL_BALANCE_SHEET = '/api/Download/balanceSheetData';
